import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewsService } from 'src/app/services/news.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import 'dotdotdot-js'
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})

export class NewsComponent implements OnInit, OnDestroy, AfterViewInit {
  language = JSON.parse(localStorage.getItem('language'))
  @ViewChildren('dot') dot: QueryList<ElementRef>
  private navigateTo: any
  choiceFromSelect: string
  pageTitle: string

  valueDropdown = [
    {
      id: 1,
      value: 'ข่าวสาร'
    },
    {
      id: 2,
      value: 'ประกาศ'
    },
    {
      id: 3,
      value: 'Earth update'
    }
  ];

  //news
  highlightNews: any;
  news: any;
  renderNews: any;
  renderAnnounce: any;
  renderEartUpdate: any;

  newsDate: any;
  monthPeriod: number;
  selectNewsPeriod = this.language.newstime1m;

  newsCurrentPage: number = 1;
  newsCurrentPage_announce: number = 1;
  newsCurrentPage_eartupdate: number = 1;

  totalNewsPage: number;
  totalNewsPage_announce: number;
  totalNewsPage_eartupdate: number;

  // Announcement
  announce: any;

  // EartUpdate
  eartupdate: any;

  flag: any

  constructor(private route: ActivatedRoute, private _newsService: NewsService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.flag = localStorage.getItem("language_flag")

    this.navigateTo = this.route.params.subscribe(params => {

      if (params['choice'] === 'News') {
        this.choiceFromSelect = params['choice']
        this.pageTitle = this.language.newsmenutab1;

        this._newsService.getLatestNews(1).subscribe(response => {
          this.highlightNews = response;

        })
        this._newsService.getNewsFromPeriod(1).subscribe(response => {
          this.news = response;
          this.totalNewsPage = this.setTotalNewsPage(this.news);
          this.setRenderNewsPerpage(this.news);
        })

      } else if (params['choice'] === 'Announcement') {
        this.choiceFromSelect = params['choice'];
        this.pageTitle = this.language.newsmenutab2;

        this._newsService.get_announceList('1').subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })

      } else if (params['choice'] === 'EarthUpdate') {
        this.choiceFromSelect = params['choice'];
        this.pageTitle = this.language.newsmenutab3;

        this._newsService.get_eartUpdateList('1').subscribe(response => {
          this.eartupdate = response;
          this.totalNewsPage_eartupdate = this.setTotalNewsPage_eartupdate(this.eartupdate);
          this.setRenderNewsPerpage_eartupdate(this.eartupdate);
        })


      }
    })
  }

  ngAfterViewInit() {
    this.dot.changes.subscribe(() => {
      this.dot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,

        })
      })
    })
  }

  ngOnDestroy() {
    this.navigateTo.unsubscribe();
  }

  setNewsPeriod(newsPeriod) {
    this.selectNewsPeriod = newsPeriod
    if (newsPeriod === this.language.newstime1m) {
      this.monthPeriod = 1;
      this._newsService.getLatestNews(this.monthPeriod).subscribe(response => {
        this.highlightNews = response;
      })
      this._newsService.getNewsFromPeriod(this.monthPeriod).subscribe(response => {
        this.news = response;
        this.totalNewsPage = this.setTotalNewsPage(this.news);
        this.setRenderNewsPerpage(this.news);
      })
    } else if (newsPeriod === this.language.newstime3m) {
      this.monthPeriod = 3
      this._newsService.getLatestNews(this.monthPeriod).subscribe(response => {
        this.highlightNews = response;
      })
      this._newsService.getNewsFromPeriod(this.monthPeriod).subscribe(response => {
        this.news = response
        this.totalNewsPage = this.setTotalNewsPage(this.news)
        this.setRenderNewsPerpage(this.news)
      })
    } else if (newsPeriod === this.language.newstime6m) {
      this.monthPeriod = 6
      this._newsService.getLatestNews(this.monthPeriod).subscribe(response => {
        this.highlightNews = response;
      })
      this._newsService.getNewsFromPeriod(this.monthPeriod).subscribe(response => {
        this.news = response
        this.totalNewsPage = this.setTotalNewsPage(this.news)
        this.setRenderNewsPerpage(this.news)
      })
    } else if (newsPeriod === this.language.newstime9m) {
      this.monthPeriod = 9
      this._newsService.getLatestNews(this.monthPeriod).subscribe(response => {
        this.highlightNews = response;
      })
      this._newsService.getNewsFromPeriod(this.monthPeriod).subscribe(response => {
        this.news = response
        
        this.totalNewsPage = this.setTotalNewsPage(this.news)
        this.setRenderNewsPerpage(this.news)
      })
    } else if (newsPeriod = 12) {
      this.monthPeriod = 12
      this._newsService.getLatestNews(this.monthPeriod).subscribe(response => {
        this.highlightNews = response;
      })
      this._newsService.getNewsFromPeriod(this.monthPeriod).subscribe(response => {
        this.news = response
        this.totalNewsPage = this.setTotalNewsPage(this.news)
        this.setRenderNewsPerpage(this.news)
      })
    }
  }

  getBackground(image) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }

  setTotalNewsPage(newsList) {
    if (newsList.length <= 6) {
      return 1;
    } else {
      return Math.ceil(newsList.length / 6);
    }
  }

  setTotalNewsPage_announce(announceList) {
    if (announceList.length <= 10) {
      return 1;
    } else {
      return Math.ceil(announceList.length / 10);
    }
  }

  setTotalNewsPage_eartupdate(eartupdateList) {
    if (eartupdateList.length <= 10) {
      return 1;
    } else {
      return Math.ceil(eartupdateList.length / 10);
    }
  }

  setRenderNewsPerpage(newsList) {
    if (newsList === undefined) {
      return null;
    } else {
      this.renderNews = newsList.slice(this.newsCurrentPage * 6 - 6, this.newsCurrentPage * 6);
    }
  }

  setRenderNewsPerpage_announce(announceList) {
    if (announceList === undefined) {
      return null;
    } else {
      this.renderAnnounce = announceList.slice(this.newsCurrentPage_announce * 10 - 10, this.newsCurrentPage_announce * 10);
    }
  }

  setRenderNewsPerpage_eartupdate(eartupdateList) {
    if (eartupdateList === undefined) {
      return null;
    } else {
      this.renderEartUpdate = eartupdateList.slice(this.newsCurrentPage_eartupdate * 10 - 10,
        this.newsCurrentPage_eartupdate * 10);
    }
  }

  setCurrentNewsPage(event) {
    this.newsCurrentPage = event;
    this.setRenderNewsPerpage(this.news);
  }

  setCurrentNewsPage_announce(event) {
    this.newsCurrentPage_announce = event;
    this.setRenderNewsPerpage_announce(this.announce);
  }

  setCurrentNewsPage_eartupdate(event) {
    this.newsCurrentPage_eartupdate = event;
    this.setRenderNewsPerpage_eartupdate(this.eartupdate);
  }

  changeFormatDate(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._newsService.changeFormatDate(date);
    }
  }

  changeFormatDate_dd(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._newsService.changeFormatDate_dd(date);
    }
  }

  changeFormatDate_mm(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._newsService.changeFormatDate_MM(date);
    }
  }

  changeFormatDate_yy(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._newsService.changeFormatDate_yy(date);
    }
  }

  selectValue(event) {
    if (event == 1) {
      this.choiceFromSelect = 'News'
      this._newsService.getLatestNews(1).subscribe(response => {
        this.highlightNews = response;
      })
      this._newsService.getNewsFromPeriod(1).subscribe(response => {
        this.news = response;
        this.totalNewsPage = this.setTotalNewsPage(this.news);
        this.setRenderNewsPerpage(this.news);
      })
    } else if (event == 2) {
      this.choiceFromSelect = 'Announcement'
      this._newsService.get_announceList('1').subscribe(response => {
        this.announce = response;

        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    }
    else if (event == 3) {
      this.choiceFromSelect = 'EarthUpdate'
      this._newsService.get_eartUpdateList('1').subscribe(response => {
        this.eartupdate = response;
        this.totalNewsPage_eartupdate = this.setTotalNewsPage_eartupdate(this.eartupdate);
        this.setRenderNewsPerpage_eartupdate(this.eartupdate);
      })
    }
  }

  date_thai(date) {
    if (date === '') {
      return null
    } else {
      return this.newsDate = this._newsService.date_thai(date)
    }
  }

  date_thai_dd(date) {
    if (date === '') {
      return null
    } else {
      return this.newsDate = this._newsService.date_thai_dd(date)
    }
  }

  date_thai_mm(date) {
    if (date === '') {
      return null
    } else {
      return this.newsDate = this._newsService.date_thai_mm(date)
    }
  }

  date_thai_yy(date) {
    if (date === '') {
      return null
    } else {
      return this.newsDate = this._newsService.date_thai_yy(date);
    }
  }

}
